import axios from 'axios';

import {
  SELECT_MAP_LAYER,
  DESELECT_MAP_LAYER,
  DESELECT_ALL_MAP_LAYERS,
  TOGGLE_BASEMAP,
  GEOJSON_LAYER_REQUEST,
  GEOJSON_LAYER_SUCCESS,
  GEOJSON_LAYER_ERROR,
  ZOOM_TO_MAP_HOME,
  ZOOM_TO_MAP_LAYER_EXTENT,
} from '../common/actionTypes';

import { s3Url } from '../common/config';

// toggling the basemap tile layer
export const toggleBasemap = basemap => ({
  type: TOGGLE_BASEMAP,
  basemap,
});

// selecting or deselecting map layers
export const selectMapLayer = layer => ({
  type: SELECT_MAP_LAYER,
  layer,
});

export const deselectMapLayer = layer => ({
  type: DESELECT_MAP_LAYER,
  layer,
});

export const deselectAllMapLayers = () => ({
  type: DESELECT_ALL_MAP_LAYERS,
});

// updating map zoom level & center programatically
export const zoomToMapHome = () => ({
  type: ZOOM_TO_MAP_HOME,
});

export const zoomToLayerExtent = layer => ({
  type: ZOOM_TO_MAP_LAYER_EXTENT,
  layer,
});

// next 4 action creators are for GeoJSON async data requests
const geojsonLayerRequest = () => ({
  type: GEOJSON_LAYER_REQUEST,
});

const geojsonLayerSuccess = (layer, json) => ({
  type: GEOJSON_LAYER_SUCCESS,
  layer,
  json,
});

const geojsonLayerError = error => ({
  type: GEOJSON_LAYER_ERROR,
  error,
});

// combines the above 3 action creators, only this one is exported
export const fetchGeoJsonLayer = datacode => {
  const url = `${s3Url}/sources/${datacode}.geojson`;

  return dispatch => {
    // first we tell the app we are making an async request so that the app can respond with a
    // loading GIF, disable certain UI interactions, etc. if desired
    dispatch(geojsonLayerRequest());
    // axios is a promise based library for handling XHR
    return axios(url)
      .then(result => {
        if (!result || !result.data) {
          throw new Error('problem loading data');
        }
        // on a successful response dispatch the appropriate action creator with the data & datacode
        dispatch(geojsonLayerSuccess(datacode, result.data));
      })
      .catch(error => dispatch(geojsonLayerError(error)));
  };
};



// WEBPACK FOOTER //
// ./src/actions/mapLayersActions.js